export default "__VITE_ASSET__DeqpHPtQ__"